//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import html2canvas from "html2canvas";
import axios from "axios";

export default {
  data() {
    return {
      buildingObj:{},//总数据
      imgUrl:'',//背景图
      height:`${window.outerHeight*1000}`,//画布高度
      width:window.outerWidth,//画布宽度
      totalPage: [],// 所有标签数据
      pageSize: 5,  // 每页显示标签数据
      pageNum: 1,// 共几页   
      currentPage: 0,// 默认当前显示第一页
      isChange:true,//标签数组点击上一页/下一页
      datainit:false
      // num:0,
      // num:0,
    };
  },
  props: {
    buildingBean: Object,//总数据
    domainContextUrl:String,//上传图片域名
    isSave:Boolean,//是否点击保存
    model: Object,//控件模型数据
    invoke: Function,//发送数据函数
    baseUrl:String,//二进制图片
    fId:String,//图片文件前缀
    appId:String,//图片文件前缀
    isSaveAndPrint:Boolean,//是否点击打印
    opResult:Boolean,//弹框是否点击是
    isOpResult:Boolean//是否打开弹框
  },
  watch:{
     buildingBean:{
       handler:function(newval,oldval){
          
                this.buildingObj=this.cloneDeepJson(this.buildingBean)//深拷贝，确保不改变main.js传过来的buildingBean
               
                if(this.buildingObj.srcImgURL){//如果图片存在
                    this.imgUrl=this.model.fileServer+this.buildingObj.srcImgURL//拼接图片地址
                    //发送图片转二进制请求
                    let value={
                        imageUrl:this.buildingObj.srcImgURL
                    }
                    let parm={content:{ type:'getImageBase64', value:value}}
                    console.log('图片换base64',parm)
                    this.invoke('invokeCustomEvent',parm) 
                    //根据图片大小设置画布
                    this.getImgInfo() 
                }else{
                     this.datainit=true
                }
            
            // }
              
       },
       deep: true
     },
    isSave:{
       handler:function(newval,oldval){
           if(this.isSave){
              console.log('调用保存',this.isSave)
              //保存数据
              this.saveDataApi()
              this.isSave=false
           }
       },
       deep: true
    },
    isSaveAndPrint:{
       handler:function(newval,oldval){
           if(this.isSaveAndPrint){
              console.log('调用保存并打印',this.isSaveAndPrint)
              //  判断是否生成
              this.saveDataBefore()
              // this.isSaveAndPrint=false
           }
       },
       deep: true
    },
     isOpResult:{
       handler:function(newval,oldval){
          if(this.isOpResult){
             console.log('调用弹框',this.isOpResult)
            if(this.opResult){
              console.log('弹框后',this.opResult)
              //确认保存且生成图片 
              this.saveImg(this.model.pageId+'mycanvas')
           }else{
             //复原后保存且生成图片
            
              this.isChange=false
              console.log('拒绝',this.opResult)
             //复原
             let temp=this.cloneDeepJson(this.buildingObj)//深拷贝，保留原始数组数据
              this.pageSize=parseInt(this.height/35)*2;//一页放的数量
              this.pageNum=Math.ceil(temp.sourceHouseShowEntryBeanList.length/this.pageSize)//一共多少页
              for (let i = 0; i < this.pageNum; i++) {
                    // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                    // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                    this.totalPage[i] = temp.sourceHouseShowEntryBeanList.slice(this.pageSize * i,this.pageSize * (i + 1))
                }
                console.log('复原数据',this.totalPage)
                setTimeout(()=>{
                   this.isChange=true
                   //页面加载后，打印图片
                   this.$nextTick(()=>{
                     this.saveImg(this.model.pageId+'mycanvas')
                   })  
                },0)
           }
           this.isOpResult=false
          }
           
       },
       deep: true
    },
    baseUrl:{
       handler:function(newval,oldval){
           if(this.baseUrl){
             console.log('图片路径',this.baseUrl)
             this.imgUrl='data:image/png;base64,'+this.baseUrl
              this.datainit=true
           }
       },
       deep: true
     },
     
  },
  created() {
     this.handleToNextStep()
  },
  methods: {
  //初始化数据
   initData(){
          //把比率转回正常值
            this.buildingObj.sourceHouseShowEntryBeanList.forEach(element => {
              if(element.label){
                element.positionX=element.positionX*this.width
                element.positionY=element.positionY*this.height
              }
            });
            console.log('转化后',this.width,this.buildingObj.sourceHouseShowEntryBeanList)
              let temp=this.cloneDeepJson(this.buildingObj)//深拷贝，保留原始数组数据
              this.pageSize=parseInt(this.height/35)*2;//一页放的数量
              this.pageNum=Math.ceil(temp.sourceHouseShowEntryBeanList.length/this.pageSize)//一共多少页
              for (let i = 0; i < this.pageNum; i++) {
                    // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                    // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                    this.totalPage[i] = temp.sourceHouseShowEntryBeanList.slice(this.pageSize * i,this.pageSize * (i + 1))
          
                }
                console.log('总数据',temp.sourceHouseShowEntryBeanList)
   },
   handleToNextStep: function () {
      console.log('初始化页面数据')
      this.invoke('invokeCustomEvent',{content:{ type: 'sourcehouseshow_init_data', value:''}})
    },
    // 上一页和下一页
    // 下一页
    nextPage() {
      if (this.currentPage === this.pageNum - 1) return ;
        this.currentPage++
    },
    // 上一页
    prePage() {
      if (this.currentPage === 0) return ;
        this.currentPage--
    },
   cloneDeepJson(obj){
      return JSON.parse(JSON.stringify(obj))
    },
     /**
     * 获取图片的真实宽高
    * @param {Image} img 
    * @param {function} callback 为了兼容旧浏览器，只能采用回调的方式得到真实的 width 和 height
    */
    getImageRealSize(img, callback) {
      if (img.naturalWidth) { // 如果支持HTML5属性，直接使用
        callback(img.naturalWidth, img.naturalHeight);
      } else {
        // 新建一个图片副本，来获取原始宽高
        var copy = new Image();
        copy.onload = function () {
          callback(copy.width, copy.height);
        };
        copy.src = img.src;
      }
    },
    //根据图片大小设置画布
    getImgInfo () {
      let img = new Image()
      img.src = this.imgUrl
      this.height=window.outerHeight*1000;//很大的值
      this.width=window.outerWidth-400;
      this.getImageRealSize(img,(width,height)=>{
           console.log('真实的图片大小',width,height)
           console.log('还没变的画布大小',this.width,this.height)
           if(width<this.width){
              this.width=width
              // this.height=(height*this.width)/width
           }
            this.height=(height*this.width)/width
        //  if(width/height>this.width/this.height){
        //     this.height=(height*this.width)/width
        //   }else{
        //     this.width=(this.height*width)/height
        //   }
          //有画布宽高后，初始化数据，转化比率
          this.initData()
          console.log('图片大小，画布大小：',width,height,this.height,this.width)
      })
    },
    //点击上传图片
     uploadInitImg(){
        console.log('点击上传图片')
        this.invoke('invokeCustomEvent',{content:{ type: 'sourcehouseshow_push_picture', value:''}})
      },
    //获取解释标签背景色
     getColorStyle(i){
      let backColor='background-color:'+i.color+';';    
      let style=backColor;
      return style
    },
    //获取标签样式位置
    getStyle(i,num,n){
       let left='';
      let top='';
       let border=''
      let backColor='background-color:'+i.color+';';
       if(i.color=='#fff'||i.color=='#FFF'||i.color=='#FFFFFF'||i.color=='#ffffff'){
          border='border:1px solid #CECECE;color:#333';
      }
      if(i.label){
        left='left:'+ i.positionX+'px;';
        top='top:'+ i.positionY+'px;opacity:1;';
      }else if(!i.label&&this.currentPage==num){ 
        let num=parseInt(this.height/35);//一列放的数量
        let wn=parseInt(n/num);//第几列
        let hn=parseInt(n%num);//第几行
        left='left:'+(this.width+20+wn*90)+'px;';
        top='top:'+35*hn+'px;opacity:1 !important;';
      }else{
        left=''
        top='opacity:0;'
      }
      
      let style=left+top+backColor+border;
      return style
    },
    //设置画布大小
    getBg(url) {
       let bg ='';
       let style=''
       style="height:"+this.height+"px;width:"+this.width+"px;"; 
      return bg+style;
    },
     //设置打印大小
    getBgBox(){
       let style=''
        style="width:"+(this.width+20)+"px;";
        return style;
    },
    /**height:"+(this.height+70)+"px;
     * 将页面指定节点内容转为图片
     * 1.拿到想要转换为图片的内容节点DOM；
     * 2.转换，拿到转换后的canvas
     * 3.转换为图片
     */
    saveImg(val) {
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // 先获取你要转换为img的dom节点
        var node = document.getElementById(val); //传入的id名称
        console.log("node", node);
        var width = node.offsetWidth; //dom宽
        var height = node.offsetHeight; //dom高
        var scale =1; //放大倍数 这个相当于清晰度 调大一点更清晰一点
        html2canvas(node, {
          width: width,
          heigth: height,
          backgroundColor: "#ffffff", //背景颜色 为null是透明
          dpi: window.devicePixelRatio * 2, //按屏幕像素比增加像素
          scale: scale,
          X: 0,
          Y: 0,
          scrollX: -3, //如果左边多个白边 设置该偏移-3 或者更多
          scrollY: 0,
          useCORS: true, //是否使用CORS从服务器加载图像 !!!
         allowTaint: true, //是否允许跨域图像污染画布  !!!
        }).then((canvas) => {
            console.log("路径", canvas.toDataURL());
           var url = canvas.toDataURL(); //这里上面不设值cors会报错
              // var a = document.createElement("a");//创建一个a标签 用来下载
              // a.download = "营销图"; //设置下载的图片名称
              // var event = new MouseEvent("click");//增加一个点击事件
              // a.href = url;//此处的url为base64格式的图片资源
              // a.dispatchEvent(event); //触发a的单击事件 即可完成下载
              console.log("路径333");
             this.uploadImg(url);
        });
    
    },
    /**
     * base64ToFile base64转文件
     * @param {String} urlData base64编码参数
     */
    base64ToFile(baseData, filename) {
      let arr = baseData.split(",");
      let type = arr[0].match(/:(.*?);/)[1]; // 解锁图片类型
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let bufferArray = new Uint8Array(n);
      console.log("111");
      while (n--) {
        bufferArray[n] = bytes.charCodeAt(n);
      }
      console.log("222");
      return new File([bufferArray], filename, { type: type });
    },
    dataURLtoBlob(toDataURL) {
				var arr = toDataURL.split(","),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
      blobToFile(Blob, fileName) {
				Blob.lastModifiedDate = new Date();
				Blob.name = fileName;
				return Blob;
			},
    //上传图片
    uploadImg(baseData) {
       console.log("上传图片");
       let param = new FormData();
      // let bold = this.dataURLtoBlob(baseData);
      // console.log("444");
      // let file = this.blobToFile(bold,"file" + Date.now() + ".png");
     let file =  this.base64ToFile(baseData,"file" + Date.now() + ".png")
       console.log("file",file);
       console.log("fId",this.fId);
       console.log("appId",this.appId);
      param.append("file", file);
      param.append("fId", this.fId);
      param.append("appId",this.appId);
       console.log("555");
      let date = new Date();
      let Y = date.getFullYear();
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
      let url=Y+M+'/'+this.appId+'/'+this.fId+'/images/file'+ + Date.now() + '.png'
      console.log("666");
      param.append(
        "url",url
      );
      console.log("上传图片参数：", param);
      let config = {
        headers: { "Content-Type": "multipart/form-data;boundary=boundary" },
      };
      axios
        .post(this.domainContextUrl+"/image/uploadImage.do", param, config)
        .then((response) => {
            console.log('图片上传后返回的结果：',response.data);
            this.saveDataPrintApi(response.data.url)
        });
    },
    //点击打印后，判断数据是否改变
    saveDataBefore(){
       //二维数组转一维
        let tempList = []
        if( this.totalPage != undefined ||  this.totalPage.length > 0){
            tempList = [].concat.apply([], this.totalPage);
        }
       //打印需要比较
          let flag = this.compareArr(tempList,this.buildingObj.sourceHouseShowEntryBeanList)
          console.log('打印比较',flag)
          console.log('新数据',tempList)
          console.log('原来数据',this.buildingObj.sourceHouseShowEntryBeanList)
          if(!flag){
            //数组不一样，弹框提示
              let value={
              }
              let parm={content:{ type:'sourcehouseshow_user_changed_record', value:value}}
              console.log('打印弹框提示',parm)
              this.invoke('invokeCustomEvent',parm)
          }else{
            //数组一样，打印
             this.saveImg(this.model.pageId+'mycanvas')
          }
    },
    //保存设置
    saveDataApi(){
           console.log('标签总数据',this.totalPage)
            let totalPageTemp=this.cloneDeepJson(this.totalPage)
            let tempList = []
            if( totalPageTemp != undefined ||  totalPageTemp.length > 0){
                tempList = [].concat.apply([], totalPageTemp);
            }
            tempList.forEach(element => {
              if(element.label){
                element.positionX=element.positionX/this.width
                element.positionY=element.positionY/this.height
              }
            });
            let value={
              labelImgURL:'',
              sourceHouseShowEntryBeanList:tempList
            }
            // this.buildingObj.sourceHouseShowEntryBeanList
            let parm={content:{ type:'sourcehouseshow_save_data', value:value}}
            console.log('保存设置上传数据',parm)
            this.invoke('invokeCustomEvent',parm) 
    },
    //保存+打印接口
     saveDataPrintApi(url=''){
            console.log('标签总数据',this.totalPage)
            let totalPageTemp=this.cloneDeepJson(this.totalPage)
            let tempList = []
            if( totalPageTemp != undefined ||  totalPageTemp.length > 0){
                tempList = [].concat.apply([], totalPageTemp);
            }
            tempList.forEach(element => {
              if(element.label){
                element.positionX=element.positionX/this.width
                element.positionY=element.positionY/this.height
              }
            });
            let value={
            labelImgURL:url,
            sourceHouseShowEntryBeanList:tempList
            }
            // this.buildingObj.sourceHouseShowEntryBeanList
            let parm={content:{ type:'sourcehouseshow_save_data_and_print', value:value}}
            console.log('打印上传数据',parm)
            this.invoke('invokeCustomEvent',parm) 
    },
    //比较俩个数据
    compareArr(arr1,arr2) {
      if(! arr1 instanceof Array || !arr2 instanceof Array){
        return true; 
      }
      if(arr1.length!= arr2.length){return false;}
      let arr1Str=JSON.stringify(arr1);
      for (let i = 0; i < arr2.length; i++) {
              if(arr1Str.indexOf(JSON.stringify(arr2[i]))==-1){
                  return false;
              }
        }
        return true;
    },
    //楼栋标签点击
    floorClick(id){
      console.log('点击')
      if(!this.buildingObj.entryCanClick){
         return
       }else{
            let value={
               id:id,
            }
            // this.buildingObj.sourceHouseShowEntryBeanList
            let parm={content:{ type:'sourcehouseshow_entry_click', value:value}}
            console.log('跳转',parm)
            this.invoke('invokeCustomEvent',parm) 
       }
    },
    mousewheelHandel(e){
     
      // let odiv = e.target; //获取目标元素
       document.onmousemove = null;
        document.onmouseup = null;
      // //算出鼠标相对元素的位置
      // let disX = e.clientX - odiv.offsetLeft;
      // let disY = e.clientY - odiv.offsetTop;
      // let disW =odiv.offsetWidth
      // let disH =odiv.offsetHeight
     
    },
    //标签移动
    move(e,num,n,id) {
      let odiv = e.target; //获取目标元素
       if(!this.buildingObj.edit){
         this.floorClick(id)
         return
       }
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      let disW =odiv.offsetWidth
      let disH =odiv.offsetHeight
      console.log(' move.clientX ', e.clientX ,e.clientY)
      let oldX=0;//画布外标签原位置
      let oldY= 0;//画布外标签原位置
      let opacity=1
      if(this.currentPage==num){ 
        let num=parseInt(this.height/35);//一列放的数量
        let wn=parseInt(n/num);//第几列
        let hn=parseInt(n%num);//第几行
        oldX= this.width+20+wn*90;
        oldY=35*hn
      }else{
         opacity=0
      }

      let oldLeft=odiv.offsetLeft;//原来位置
      let oldTop=odiv.offsetTop;//原来位置
      console.log('原来位置',oldLeft,oldTop)
      let isMove=true//是否移动
     
      document.onmousemove = (e) => {
        //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        console.log('移动',left,top)
        isMove=false
        //绑定元素位置到positionX和positionY上面
       this.totalPage[num][n].positionX = left;
       this.totalPage[num][n].positionY = top;
        // console.log(left, top, "位置");
        //移动当前元素
        // odiv.style.right='auto'
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.onmouseup = (e) => {

        console.log('移动后位置：',this.totalPage[num][n].positionX,this.totalPage[num][n].positionY);
        if((this.totalPage[num][n].positionY==oldTop&&this.totalPage[num][n].positionX==oldLeft)||isMove){//如果位置没有移动，就是点击
           this.floorClick(id)
        }
        let positionX=this.totalPage[num][n].positionX;
        let positionY=this.totalPage[num][n].positionY;
        this.totalPage[num][n].label=true

        if(positionX<0||positionX>this.width-disW){
           console.log('宽度不合格')
          this.totalPage[num][n].positionX = oldX;
          this.totalPage[num][n].positionY = oldY;
          this.totalPage[num][n].label=false
            odiv.style.left = oldX + "px";
            odiv.style.top = oldY + "px";
            odiv.style.opacity = opacity
        }
        if(positionY<0||positionY>this.height-disH){
           console.log('高度不合格')
          this.totalPage[num][n].positionX = oldX;
          this.totalPage[num][n].positionY = oldY;
          this.totalPage[num][n].label=false
           odiv.style.left = oldX + "px";
           odiv.style.top = oldY + "px";
           odiv.style.opacity = opacity
        }
        document.onmousemove = null;
        document.onmouseup = null;
       }
     
    },
  },
};
